import { render, staticRenderFns } from "./BaseLoginPhone.vue?vue&type=template&id=40ccc749&scoped=true&"
import script from "./BaseLoginPhone.vue?vue&type=script&lang=js&"
export * from "./BaseLoginPhone.vue?vue&type=script&lang=js&"
import style0 from "./BaseLoginPhone.vue?vue&type=style&index=0&id=40ccc749&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ccc749",
  null
  
)

export default component.exports